<template>
    <div>
        <div class="is-clearfix has-background-white columns " style="padding: 10px;margin-top:20px;min-height: 380px; border-radius: 10px;">
            <template v-if="loading && !error">
                <div class="column"></div>
                <p class="column is-three-quarters content has-text-centered is-size-6" style="padding-top:120px;">
                    正在加载...
                </p>
                <div class="column"></div>
            </template>
            <template v-if="error">
                <div class="column"></div>
                <p class="column is-three-quarters content has-text-centered is-size-5 has-text-weight-semibold animated rubberBand" style="padding-top:120px;">
                    请通过
                    <span class="is-size-4 has-text-danger">报名序号</span>
                    和
                    <span class="is-size-4 has-text-danger">身份证号</span>
                    进行查询
                </p>
                <div class="column"></div>
            </template>
            <template v-if="!loading && !error">
                <div class="column"></div>
                <div class="column is-three-quarters  box has-text-centered" style="margin-top: 20px;">
                    <div class="is-size-4 has-text-weight-semibold">{{ result.plan.name }}</div>
                    <div class="is-size-6 has-text-weight-semibold" style="margin-top: 20px; margin-bottom: 20px;">
                        报名岗位：
                        <span class="is-normal tag is-link">[{{ result.post.code }}] {{ result.post.name }}</span>
                    </div>
                    <div class="columns" style="margin-top: 20px; border: 1px dashed green; margin:10px;">
                        <p class="column">
                            考生姓名：
                            <span class="has-text-danger">{{ result.name }}</span>
                        </p>
                        <p class="column">
                            身份证号：
                            <span class="has-text-danger">{{ result.idno }}</span>
                        </p>
                        <p class="column">
                            报名序号：
                            <span class="has-text-danger">{{ result.sno }}</span>
                        </p>
                    </div>
                    <div class="columns">
                        <div class="column"></div>
                        <div class="column is-four-fifths">
                            <table class="table is-striped is-hoverable is-fullwidth has-text-centered ">
                                <thead>
                                    <tr>
                                        <th style="width: 5%;">#</th>
                                        <th style="width: 65%;">进度</th>
                                        <th style="width: 30%;">状态</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <span class="icon is-medium has-text-success">
                                                <i class="fa fa-check"></i>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="has-text-weight-semibold">提交报名资料</span>
                                            <br />
                                            <span class="is-size-7">[ {{ result.plan.regs }} 至 {{ result.plan.rege }} ]</span>
                                        </td>
                                        <td>
                                            <router-link
                                                v-if="result.cwrf && (result.state === 'Wait' || result.state === 'Reject')"
                                                :to="{ name: 'RecPostReg', query: { rid: result.id, id: result.post.id, pid: result.plan.id } }"
                                            >
                                                <button type="button" class="button is-danger is-outlined is-small">修改/提交报名信息</button>
                                            </router-link>
                                            <span v-else class="tag is-success ">已报名成功</span>
                                        </td>
                                    </tr>
                                    <tr v-if="result.state === 'Wait'">
                                        <td>
                                            <span class="icon is-medium has-text-primary">
                                                <i class="fa fa-spin fa-refresh"></i>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="has-text-weight-semibold">报名资质审核</span>
                                            <br />
                                            <span class="is-size-7">[ 当前正在审核中或您还没有提交系统审核 ]</span>
                                        </td>
                                        <td>
                                            <span class="tag is-primary ">审核中/未提交审核</span>
                                        </td>
                                    </tr>
                                    <tr v-if="result.state != 'Wait' && result.state != 'Reject' && result.state != 'Cancel'">
                                        <td>
                                            <span class="icon is-medium has-text-success">
                                                <i class="fa fa-check"></i>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="has-text-weight-semibold">报名资质审核</span>
                                            <br />
                                            <span class="is-size-7">[ 您的报名资质已通过审核 ]</span>
                                        </td>
                                        <td>
                                            <span class="tag is-success ">已通过审核</span>
                                        </td>
                                    </tr>
                                    <tr v-if="result.state === 'Reject' || result.state == 'Cancel'">
                                        <td>
                                            <span class="icon is-medium has-text-danger">
                                                <i class="fa fa-close"></i>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="has-text-weight-semibold">报名资质审核</span>
                                            <br />
                                            <span class="is-size-7">
                                                [ 未通过审核，原因：
                                                <b class="tag is-danger is-light" style=" width: 200px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;" :title="result.audit.memo">
                                                    {{ result.audit.memo }}
                                                </b>
                                                ]
                                            </span>
                                        </td>
                                        <td>
                                            <span class="tag is-danger ">未通过审核</span>
                                        </td>
                                    </tr>
                                    <tr v-if="(result.state === 'Wait' || result.state == 'Reject') && result.post.fee != `0.00`">
                                        <td>
                                            <span class="icon is-medium has-text-dark">
                                                <i class="fa fa-pause"></i>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="has-text-weight-semibold">支付报名费</span>
                                            <br />
                                            <span class="is-size-7">[ 截至时间：{{ result.plan.paye }}，费用：{{ result.post.fee }}元 ]</span>
                                        </td>
                                        <td>
                                            <span class="tag is-info  ">等待审核</span>
                                        </td>
                                    </tr>
                                    <tr v-if="result.state === 'Pass' && result.post.fee != `0.00`">
                                        <td>
                                            <span class="icon is-medium has-text-warning">
                                                <i class="fa fa-spin fa-refresh"></i>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="has-text-weight-semibold">支付报名费</span>
                                            <br />
                                            <span class="is-size-7">[ 截至时间：{{ result.plan.paye }}，费用：{{ result.post.fee }}元 ]</span>
                                        </td>
                                        <td>
                                            <div v-if="result.crfp" class="buttons are-small  is-centered">
                                                <button type="button" class="button is-warning" @click="doAlipay">支付宝</button>
                                                <button type="button" class="button is-warning" @click="doWxpay">微信支付</button>
                                            </div>
                                            <span v-else class="tag is-dark  ">支付已截至</span>
                                        </td>
                                    </tr>
                                    <!-- <tr v-if="result.post.fee == `0.00`">
                                        <td>
                                            <span class="icon is-medium has-text-success">
                                                <i class="fa fa-check"></i>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="has-text-weight-semibold">支付报名费</span>
                                            <br />
                                            <span class="is-size-7">[ 本岗位无需支付报名费 ]</span>
                                        </td>
                                        <td>
                                            <button v-if="result.cprt" type="button" class="button is-link is-small " @click="doPrintRegt">打印报名表</button>
                                            <span v-else class="tag is-success ">已支付成功</span>
                                        </td>
                                    </tr> -->
                                    <tr v-if="(result.state === 'Paid' || result.state === 'Finish') && result.post.fee != `0.00`">
                                        <td>
                                            <span class="icon is-medium has-text-success">
                                                <i class="fa fa-check"></i>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="has-text-weight-semibold">支付报名费</span>
                                            <br />
                                            <span class="is-size-7">[ 支付时间：{{ result.ptime }}，费用：{{ result.post.fee }}元 ]</span>
                                        </td>
                                        <td>
                                            <button v-if="result.cprt" type="button" class="button is-link is-small " @click="doPrintRegt">打印信息表</button>
                                            <span v-else class="tag is-success ">已支付成功</span>
                                        </td>
                                    </tr>
                                    <tr v-if="result.state != 'Finish'">
                                        <td>
                                            <span class="icon is-medium has-text-success">
                                                <i class="fa fa-check"></i>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="has-text-weight-semibold">打印准考证</span>
                                            <br />
                                            <span class="is-size-7">[ 请在规定的时间内完成准考证的打印 ]</span>
                                            <!-- <span class="is-size-7">[ {{ result.plan.prints }} 至 {{ result.plan.printe }} ]</span> -->
                                        </td>
                                        <td>
                                            <span class="tag is-dark ">已结束或未开始</span>
                                            <!-- <span class="tag is-info  ">暂不可打印</span> -->
                                        </td>
                                    </tr>
                                    <tr v-if="result.state === 'Finish'">
                                        <td>
                                            <span class="icon is-medium has-text-success">
                                                <i class="fa fa-spin fa-refresh"></i>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="has-text-weight-semibold">打印准考证</span>
                                            <br />
                                            <span class="is-size-7">
                                                [ 准考证编号：
                                                <b class="tag is-success is-light">{{ result.zkzno }}</b>
                                                ]
                                            </span>
                                            <br />
                                            <span class="is-size-7">[ 请在规定的时间内完成准考证的打印 ]</span>
                                            <!-- <span class="is-size-7">[ {{ result.plan.prints }} 至 {{ result.plan.printe }} ]</span> -->
                                        </td>
                                        <td>
                                            <button v-if="result.cpzz" type="button" class="button is-warning is-small " @click="doPrintZkzt">打印准考证</button>

                                            <span v-else class="tag is-info  ">暂不可打印</span>
                                        </td>
                                    </tr>
                                    <tr v-if="result.caiv">
                                        <td>
                                            <span class="icon is-medium has-text-success">
                                                <i class="fa fa-spin fa-refresh"></i>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="has-text-weight-semibold">打印面试通知单</span>
                                            <br />
                                            <span class="is-size-7">[ 请在规定的时间内完成面试单的打印 ]</span>
                                        </td>
                                        <td>
                                            <button type="button" v-if="mianshi" class="button is-warning is-small " @click="doPrintMsd">打印面试通知单</button>
                                            <span v-else class="tag is-info  ">暂不可打印</span>
                                        </td>
                                    </tr>
                                    <!-- <tr v-if="result.state === 'End'">
                                        <td>
                                            <span class="icon is-medium has-text-dark">
                                                <i class="fa fa fa-exclamation-circle"></i>
                                            </span>
                                        </td>
                                        <td>
                                            <span class="has-text-weight-semibold"></span>
                                        </td>
                                        <td>
                                            <span class="tag is-dark ">已结束</span>
                                        </td>
                                    </tr> -->
                                </tbody>
                            </table>
                        </div>
                        <div class="column"></div>
                    </div>
                    <!-- 作弊模式 -->
                    <div style="padding: 10px; border: 1px dashed red; margin:10px; text-align: left;" v-if="zuobi">
                        <h2 style="color:red;padding:5px;">
                            作弊模式常用功能区：
                        </h2>
                        <div><button type="button" class="button is-warning is-small " @click="doPrintMsd">打印面试通知单</button></div>
                    </div>
                </div>
                <div class="column"></div>
            </template>
        </div>
        <mu-dialog title="报名费支付" width="400" :open.sync="dialogVisible" :esc-press-close="false" :overlay-close="false">
            <div style="text-align: center;">
                <img style="margin: 0px auto; width: 300px; height: 300px;" :src="pay.qr" />

                <p style="margin-top: 10px;">
                    请打开
                    <span class="has-text-danger is-size-5 has-text-weight-semibold	">[ {{ pay.cnl }} ]</span>
                    支付报名费
                    <span class="has-text-danger is-size-5 has-text-weight-semibold	">[ {{ result.post.fee }} ]</span>
                    元
                </p>
                <p style="margin-top: 10px;">[ {{ pay.id }} ]</p>
            </div>
            <mu-button slot="actions" flat color="warning" @click="doPayCancel">取消支付</mu-button>
            <mu-button slot="actions" flat color="primary" @click="doPayFinish">支付成功</mu-button>
        </mu-dialog>
        <!-- <el-dialog title="报名费支付" :visible.sync="dialogVisible" width="400px" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div style="text-align: center;">
                <img style="margin: 0px auto; width: 300px; height: 300px;" :src="pay.qr" />

                <p style="margin-top: 10px;">
                    请打开
                    <span class="has-text-danger is-size-5 has-text-weight-semibold	">[ {{ pay.cnl }} ]</span>
                    支付报名费
                    <span class="has-text-danger is-size-5 has-text-weight-semibold	">[ {{ result.post.fee }} ]</span>
                    元
                </p>
                <p style="margin-top: 10px;">[ {{ pay.id }} ]</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="doPayCancel">取消支付</el-button>
                <el-button type="primary" @click="doPayFinish">支付成功</el-button>
            </span>
        </el-dialog> -->
    </div>
</template>

<script>
export default {
    name: 'RecPostReg',
    data() {
        return {
            zuobi: false,
            mianshi: false,
            error: false,
            loading: true,
            sno: '',
            idno: '',
            result: {
                post: {}
            },
            dialogVisible: false,
            pay: {}
        }
    },
    mounted() {
        let time = parseInt(new Date().getTime() / 1000) + ''
        // 2024-05-16 07:00:00 => 1715814000
        // 2024-05-19 07:00:00 => 1716073200
        if (time > 1721178000 && time < 1721448000) {
            this.mianshi = true
        } else {
            this.mianshi = false
        }
        // console.log(this.mianshi)
        this.init()
    },
    methods: {
        init() {
            this.sno = this.$route.query.sno
            this.idno = this.$route.query.idno
            if (!this.sno || !this.idno) {
                this.error = true
                return
            }
            // if (this.sno === 'HFTFGNTAR96A9' || this.sno === '9LXPK2NQRZJG5' || this.sno === 'PKK1X2PYAHNFJ' || this.sno === 'HLT6YYFUSSKJZ' || this.sno === '8RSFIEE0IXKGB' || this.sno === 'AJOSMXKWDQSSH') {
            // this.mianshi = false
            // }
            this.doLoad()
        },
        alert(info) {
            this.$message.error({
                message: info,
                center: true,
                type: 'error'
            })
        },
        doLoad() {
            // 上帝模式
            let shangdi = this.$route.query.zbm
            let shenfenzheng = this.$route.query.idno.substring(14, 18)
            let sno = this.$route.query.sno.substring(0, 4)
            let d = new Date()
            let minuter = d.getMinutes()
            let zuomima = shenfenzheng + minuter + sno
            if (shangdi === zuomima) {
                this.zuobi = true
            }
            //  上帝模式
            this.$http
                .get('/app/rec/reg/state', {
                    params: {
                        _: new Date().getTime(),
                        idno: this.$route.query.idno,
                        sno: this.$route.query.sno
                    }
                })
                .then(result => {
                    if (result.code === 70) {
                        this.$router.push({ name: 'RecPlanList' })
                    }
                    this.result = result.data
                    this.loading = false
                })
        },
        doAlipay() {
            this.pay = {}
            if (!this.result.id) {
                return
            }
            this.$http
                .post('/app/rec/pay/create', {
                    rid: this.result.id,
                    cnl: 'Aliqr'
                })
                .then(result => {
                    if (result.code === 0) {
                        this.pay = result.data
                        this.pay.cnl = '支付宝'
                        this.dialogVisible = true
                    }
                })
        },
        doWxpay() {
            this.pay = {}
            if (!this.result.id) {
                return
            }
            this.$http
                .post('/app/rec/pay/create', {
                    rid: this.result.id,
                    cnl: 'Wxqr'
                })
                .then(result => {
                    if (result.code === 0) {
                        this.pay = result.data
                        this.pay.cnl = '微信'
                        this.dialogVisible = true
                    }
                })
        },
        doPayFinish() {
            if (!this.pay.id) {
                return
            }
            this.$http
                .get('/app/rec/pay/state', {
                    params: {
                        _: new Date().getTime(),
                        id: this.pay.id
                    }
                })
                .then(result => {
                    if (result.code == 0) {
                        if (result.data.st === 'Success') {
                            this.doLoad()
                            this.dialogVisible = false
                        } else if (result.data.st === 'Wait') {
                            this.alert('尚未完成支付')
                        } else {
                            this.alert('支付未成功，请重新支付')
                            this.dialogVisible = false
                        }
                    }
                })
        },
        doPayCancel() {
            if (!this.pay.id) {
                return
            }
            this.$http
                .post('/app/rec/pay/cancel', {
                    id: this.pay.id
                })
                .then(result => {
                    if (result.code === 0) {
                        this.pay = {}
                        this.dialogVisible = false
                    }
                })
        },
        doPrintRegt() {
            if (!this.result.id) {
                return
            }
            this.$http
                .get('/app/rec/reg/table', {
                    params: {
                        _: new Date().getTime(),
                        id: this.result.id
                    }
                })
                .then(result => {
                    if (result.code == 0) {
                        let win = window.open()
                        win.document.write(result.data.info)
                        win.document.close()
                        win.focus()
                    }
                })
        },
        formattedDate() {
            const date = new Date()
            const year = date.getFullYear()
            const month = (date.getMonth() + 1).toString().padStart(2, '0')
            const day = date
                .getDate()
                .toString()
                .padStart(2, '0')
            const hour = date
                .getHours()
                .toString()
                .padStart(2, '0')
            const minute = date
                .getMinutes()
                .toString()
                .padStart(2, '0')
            const second = date
                .getSeconds()
                .toString()
                .padStart(2, '0')
            const formattedDate = `${year}-${month}-${day} ${hour}:${minute}:${second}`
            return formattedDate
        },

        doPrintZkzt() {
            if (!this.result.id) {
                return
            }
            this.$http
                .get('/app/rec/reg/zkz', {
                    params: {
                        _: new Date().getTime(),
                        id: this.result.id,
                        now: this.formattedDate()
                    }
                })
                .then(result => {
                    if (result.code == 0) {
                        let win = window.open()
                        win.document.write(result.data.info)
                        win.document.close()
                        win.focus()
                    }
                })
        },
        doPrintMsd() {
            if (!this.result.id) {
                return
            }
            this.$http
                .get('/app/rec/reg/notice', {
                    params: {
                        _: new Date().getTime(),
                        id: this.result.id,
                        now: this.formattedDate()
                    }
                })
                .then(result => {
                    if (result.code == 0) {
                        let win = window.open()
                        win.document.write(result.data.info)
                        win.document.close()
                        win.focus()
                    }
                })
        }
    }
}
</script>

<style scoped>
td {
    vertical-align: middle !important;
    text-align: center !important;
}
th {
    vertical-align: middle !important;
    text-align: center !important;
}
</style>
